// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_wyVov","indicator":"indicator_4oPq0","indicator-green":"indicator-green_SwXA8","indicator-red":"indicator-red_RJP+9"};